<template>
    <div>
        <iu-nav>
            <iu-nav-item>
                <div id="logo">
                    <a href="/">Walter</a>
                </div>
            </iu-nav-item>
            <iu-nav-item>
                <iu-input placeholder="Please search" v-model="searchText" @change="doSearch">{{ areas }}</iu-input>
            </iu-nav-item>
            <iu-nav-item v-if="isLoggedIn" id="user-menu">
                <div @click="openUserMenu">
                    <iu-avatar>{{ getNameInitial }}</iu-avatar>
                </div>
            </iu-nav-item>
        </iu-nav>
    </div>
</template>

<script>
export default {
    name: 'Search',
    data: () => {
        return {
            searchText: '',
            showUserMenu: false,
        };
    },
    methods: {
        doSearch() {
            // if (this.search === '') return;
            // this.$store.commit('setSearchText', this.searchText);
            // this.updateRoute(this.searchText);
        },
        updateRoute(query) {
            let path = query ? 'Search' : 'Main';
            this.$router
                .push({
                    name: path,
                    query: {
                        q: query,
                    },
                    params: {
                        q: query,
                    },
                })
                // eslint-disable-next-line no-unused-vars
                .catch(err => {});
        },
        openUserMenu() {
            // this.showUserMenu = true;
            this.$router
                .push({
                    name: 'Profile',
                })
                // eslint-disable-next-line no-unused-vars
                .catch(err => {
                    // console.error(err);
                });
        },
    },
    computed: {
        areas() {
            return this.$store.state.search.text;
        },
        isLoggedIn() {
            return !!this.$store.state.user.uid;
        },
        getNameInitial() {
            const userName = this.$store.state.user.name || this.$store.state.user.displayName || '?';

            return userName
                .toString()
                .substring(0, 1)
                .toUpperCase();
        },
    },
};
</script>

<style lang="scss" scoped>
#logo {
    font-weight: bold;
    font-size: 1.4rem;
}

#logo a {
    text-decoration: unset;
    color: black;
}

#user-menu {
    margin-left: auto;

    div {
        cursor: pointer;
    }
}
</style>
